import { getColorByTemperature } from '../utils';

export function TemperatureDisplay({
  temperature,
  className = '',
  weatherOfTheDay,
}: {
  temperature: number;
  className?: string;
  weatherOfTheDay: {
    maxTemperatur: { einheit: string };
    minTemperatur: { einheit: string };
  }[];
}) {
  const color = getColorByTemperature(temperature);
  const weatherUnit = weatherOfTheDay
    .map((entry) => entry.maxTemperatur.einheit)
    .every((unit) => unit === 'C')
    ? '°'
    : '';

  return (
    <div className={`text-base ${color} ${className}`}>
      {temperature}
      {weatherUnit}
    </div>
  );
}
